import React from "react";
import { Route, Routes } from "react-router-dom";

import Subject from "@/components/screens/Subject";
import SubjectFormPage from "@/components/screens/SubjectFormPage";
import { SUBJECT_FORM_MESSAGES } from "@/messages/subject/subject-form.messages";
import { SUBJECT_MESSAGES } from "@/messages/subject/subject.messages";

const SubjectPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<Subject messages={SUBJECT_MESSAGES} />} />
      <Route
        path="/create/:lang"
        element={<SubjectFormPage messages={SUBJECT_FORM_MESSAGES} />}
      />
      <Route
        path="/update/:subjectId/:lang"
        element={<SubjectFormPage messages={SUBJECT_FORM_MESSAGES} />}
      />
      <Route
        path="/view/:subjectId/:lang"
        element={<SubjectFormPage messages={SUBJECT_FORM_MESSAGES} isViewing />}
      />
      <Route path="/" element={<Subject messages={SUBJECT_MESSAGES} />} />
    </Routes>
  );
};

export default SubjectPage;
